import {
  Component,
  Inject,
  Injector,
  forwardRef,
  ViewEncapsulation,
  ContentChildren,
  ContentChild,
  QueryList,
  ElementRef,
  Renderer,
  AfterContentInit,
  Optional,
  ViewChild,
  NgModule
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MdLine, MdListAvatarCssMatStyler, MdListItem } from '@angular/material';
import { OListComponent } from '../o-list.component';
import { OSharedModule } from '../../../shared';



export class OListItemComponent implements AfterContentInit {

  modelData: Object;
  protected _isSelected: boolean = false;

  _hasFocus: boolean = false;

   _lines: QueryList<MdLine>;

   _innerListItem: MdListItem;

  
  set _hasAvatar(avatar: MdListAvatarCssMatStyler) {
    let mdListItemNativeEl = this.elRef.nativeElement.getElementsByTagName('mat-list-item');
    if (mdListItemNativeEl && mdListItemNativeEl.length === 1) {
      this._renderer.setElementClass(mdListItemNativeEl[0], 'mat-list-avatar', (avatar !== null && avatar !== undefined));
    }
  }

  constructor(
    public elRef: ElementRef,
    protected _renderer: Renderer,
    protected _injector: Injector,
      public _list: OListComponent
  ) {
  }

  ngAfterContentInit() {
    var mdLinesRef = this._lines;
    var ngAfterContentInitOriginal = this._innerListItem.ngAfterContentInit;
    this._innerListItem.ngAfterContentInit = function () {
      let emptyDiv = this._element.nativeElement.querySelector('.mat-list-text:empty');
      if (emptyDiv) {
        emptyDiv.remove();
      }
      this._lines = mdLinesRef;
      ngAfterContentInitOriginal.apply(this);
    };
  }

  onItemClick(evt) {
    if (!this._list.detailButtonInRow) {
      this._list.onItemDetailClick(this);
    }
  }

  onItemDblClick(evt) {
    if (!this._list.detailButtonInRow) {
      this._list.onItemDetailDblClick(this);
    }
  }

  onDetailIconClicked(evt) {
    this._list.viewDetail(this.modelData);
  }

  onEditIconClicked(evt) {
    this._list.editDetail(this.modelData);
  }

  setItemData(data) {
    if (!this.modelData) {
      this.modelData = data;
      if (this._list.selectable) {
        this.isSelected = this._list.isItemSelected(this.modelData);
      }
    }
  }

  getItemData() {
    return this.modelData;
  }

  onCheckboxChange(evt) {
    if (this._list.selectable) {
      this.isSelected = this._list.setSelected(this.modelData);
    }
  }



  get isSelected() : boolean {
    return this._isSelected;
  }

  set isSelected(val : boolean) {
    this._isSelected = val;
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'o-list-item',
  template: `
    <md-list-item #innerListItem>
      <div class="o-list-row-action" *ngIf="_list && _list.selectable">
        <md-checkbox [checked]="isSelected" (change)="onCheckboxChange($event)">
        </md-checkbox>
      </div>
      <ng-content select="[o-list-item-avatar],
        [mdListAvatar], [mdListIcon],
        [matListAvatar], [matListIcon]">
      </ng-content>
      <div class="mat-list-text">
        <ng-content select="[mdLine], [matLine]"></ng-content>
      </div>
      <ng-content></ng-content>
      <div fxLayout="row" class="row-buttons-container">
        <div class="o-list-row-action o-list-item-icon" *ngIf="_list && _list.editButtonInRow" (click)="onEditIconClicked($event)">
          <md-icon class="material-icons">{{ _list.editButtonInRowIcon }}</md-icon>
        </div>
        <div class="o-list-row-action o-list-item-icon" *ngIf="_list && _list.detailButtonInRow" (click)="onDetailIconClicked($event)">
          <md-icon class="material-icons">{{ _list.detailButtonInRowIcon }}</md-icon>
        </div>
      </div>
    </md-list-item>
  `,
  styles: [`
    .o-list-item .row-buttons-container .o-list-row-action{height:24px;text-align:center;cursor:pointer}.mat-list .mat-checkbox-inner-container{margin:0}.mat-list[dense] .o-list-item .o-list-row-action .mat-checkbox-inner-container{height:16px;width:16px;margin:0}
  `],
  encapsulation: ViewEncapsulation.None,
  host: {
    '[class.o-list-item]': 'true'
  }
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: Renderer, },
{type: Injector, },
{type: OListComponent, decorators: [{ type: Optional }, { type: Inject, args: [forwardRef(() => OListComponent), ] }, ]},
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'_lines': [{ type: ContentChildren, args: [MdLine, ] },],
'_innerListItem': [{ type: ViewChild, args: ['innerListItem', ] },],
'_hasAvatar': [{ type: ContentChild, args: [MdListAvatarCssMatStyler, ] },],
};
}


export class OListItemModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [OListItemComponent],
  imports: [OSharedModule, CommonModule],
  exports: [OListItemComponent],
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
